import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Box from '@mui/material/Box';
import { useTheme } from "@mui/material/styles";
import Typography from '@mui/material/Typography';


const SpeakerIcon = ({ speaker }) => {
    const theme = useTheme();
    // Generate a unique color based on the speaker name
    const getColorForSpeaker = (speaker) => {
        const colors = [
            theme.palette.primary.main,
            theme.palette.secondary.main,
            theme.palette.error.main,
            theme.palette.warning.main,
            theme.palette.info.main,
            theme.palette.success.main,
        ];
        const index = speaker.charCodeAt(0) % colors.length;
        return colors[index];
    };

    return (
        <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <AccountCircleIcon sx={{ color: getColorForSpeaker(speaker) }} />
            <Typography
                sx={{
                    position: 'absolute',
                    fontSize: '0.7rem',
                    fontWeight: 'bold',
                    color: 'white'
                }}
            >
                {speaker.charAt(0).toUpperCase()}
            </Typography>
        </Box>
    );
}

export default SpeakerIcon;